import React from 'react';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { SearchBox } from 'fw/forms';
import { DD214Status, ServiceBranchCombo, GenderCombo } from 'areas/shared/controls'
import { SetupSearch } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API'
import { withRouter } from 'react-router-dom';

class Search extends SetupSearch {

    initialForm() {
        return {
            firstName: "",
            lastName: "",
            ownerSSN: "",
            genderCode: "",
            serviceBranchId: null,
            certificationKey: this.props.match.params.certificationKey,
            dd214Status: null
        };
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    searchLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: {
                type: 'sponsor'
            }
        }
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={9}>
                        <Row>
                            <Col md={3}>
                                <FormGroup>
                                    <SearchBox
                                        name="lastName"
                                        label="searchText"
                                        placeholder="Last name..."
                                        loader={this.searchLoader}
                                        maxLength={40} />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <SearchBox
                                        name="firstName"
                                        label="searchText"
                                        placeholder="First name..."
                                        loader={this.searchLoader}
                                        ref={(c) => { this.focusControl = c }}
                                        maxLength={40} />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <SearchBox
                                        name="ownerSSN"
                                        label="searchText"
                                        placeholder="SSN (NNN-NN-NNNN)..."
                                        loader={this.searchLoader}
                                        maxLength={11} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <FormGroup>
                                    <ServiceBranchCombo
                                        clearable
                                        name='serviceBranchId'
                                        placeholder="Branch of Service" />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <GenderCombo
                                        clearable
                                        name='genderCode'
                                        placeholder="Gender" />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <DD214Status name="dd214Status" 
                                        clearable
                                        placeholder="Status" />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default withRouter(Search);



// WEBPACK FOOTER //
// ./src/areas/admin/dd214Setup/Search.js